import { useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { setSnackbarRef } from '../../utils/snackbarUtils';

const SnackbarUtilsConfigurator = () => {
  const snackbar = useSnackbar();
  useEffect(() => {
    setSnackbarRef(snackbar);
  }, [snackbar]);
  return null;
};

export default SnackbarUtilsConfigurator;
